export default __webpack_public_path__ + "static/author1_icon-ec9fee7791f25ebb0271954b0270f942.png";